<template>
    <div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">Proyectos</li>
                <li class="breadcrumb-item active" aria-current="page">Pendientes por firmar contratos</li>
            </ol>
        </nav>
        
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <md-card>
                        <md-card-header>
                            <md-card-header-text>
                                <div class="md-title">Programa ImpactaMás</div>
                            </md-card-header-text>
                        </md-card-header>

                        <md-card-content>
                            <h5 class="card-title">Buscar Proveedor</h5>
                            <div class="row">
                                <div class="col-md-11">
                                    <input type="text" placeholder="Buscar proveedor..." class="form-control" v-model="search" v-on:keyup.enter="getImpactaMasSuppliers()">
                                </div>
                                <div class="col-md-1">
                                    <vs-button radius color="success" type="filled" icon="search" @click="getImpactaMasSuppliers()"></vs-button>
                                </div>
                            </div>
                            <small>Criterios de busqueda: SID, UID, Nombre, Razón social, Nombre Comercial y Nivel.</small>
                            <vs-table :data="suppliers" stripe pagination max-items="15" noDataText="No hay datos disponibles">
                                <template slot="thead">
                                    <vs-th class="bold" v-for="(col, idx) in columns" v-bind:key="idx" :sort-key="col.sortable ? col.key : null" >{{col.title}}</vs-th>
                                </template>
                                <template slot-scope="{data}">
                                    <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                                        <vs-td :data="data[indextr].SID">
                                            <vs-button type="line" @click="handleSelected(tr.SID)">{{tr.SID}}</vs-button>
                                        </vs-td>
                                        <vs-td :data="data[indextr].UID">
                                            {{tr.UID}}
                                        </vs-td>
                                        <vs-td :data="data[indextr].name">
                                            {{tr.name}}
                                        </vs-td>
                                        <vs-td :data="data[indextr].comercial">
                                            {{tr.comercial}}
                                        </vs-td>
                                        <vs-td :data="data[indextr].level">
                                            {{tr.level}}
                                        </vs-td>
                                        <vs-td :data="data[indextr].bonus">
                                            {{tr.bonus != null ? explicitMoneyFormat(tr.bonus) : "$0.00"}}
                                        </vs-td>
                                        <vs-td :data="data[indextr].billing">
                                            {{tr.billing != 0 ? explicitMoneyFormat(tr.billing) : "$0.00"}}
                                        </vs-td>
                                        <vs-td :data="data[indextr].penalty">
                                            <vs-chip class="ml-3 mt-1 bold" :color="tr.penalty == 0 ? '#4caf50' : '#f44336'"> {{tr.penalty == 0 ? "SIN PENALIZAR" : "PENALIZADO"}}</vs-chip>
                                        </vs-td>
                                    </vs-tr>
                                </template>
                            </vs-table>
                        </md-card-content>
                    </md-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import formatHelper from '@components/mixins/formatHelper';

    const columnDefinitions = [
        { title: "SID", key: "SID", sortable: true },
        { title: "UID", key: "UID", sortable: true },
        { title: "NOMBRE/RAZÓN SOCIAL", key: "name", sortable: true },
        { title: "NOMBRE COMERCIAL", key: "comercial", sortable: true },
        { title: "NIVEL", key: "level", sortable: true },
        { title: "BONOS", key: "bonus", sortable: true },
        { title: "FACTURACIÓN", key: "billing", sortable: false },
        { title: "ESTADO", key: "penalty", sortable: false }
    ];
    export default {
        mixins: [formatHelper],
        name: "ImpactaMasSupplier",
        data() {
            return {
                columns: columnDefinitions
                , search: ""
                , suppliers: {
                    SID: 0,
                    UID: 0,
                    name: "",
                    comercial: "",
                    billing: 0,
                    level: "00",
                    penalty: 0,
                    bonus: 0,
                    priority: 0
                }
            }
        },
        methods:{
            async getImpactaMasSuppliers() {
                this.showLoading(true);
                await axios.get(`/api/suppliers/getImpactaMasSupplier?search=${this.search}`)
                .then(response => {
                    this.suppliers = response.data;
                }).catch(error => {
                    this.errorNotif(error.response.data.message, error.response.data.errors);
                });
                this.showLoading(false);
            },
            async handleSelected(id){
                window.open(`/suppliers/${id}`, '_blank');
            },
        },
        created() {
            this.getImpactaMasSuppliers();
        }
    }
</script>

<style scoped>

</style>